/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentSchedulesListAgentSchedules } from "../../funcs/agentSchedulesListAgentSchedules.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListAgentSchedulesRequest$inboundSchema,
};

export const tool$agentSchedulesListAgentSchedules: ToolDefinition<
  typeof args
> = {
  name: "agent-schedules-list-agent-schedules",
  description: `List schedules for an agent`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentSchedulesListAgentSchedules(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
